import React, { useEffect } from "react";
import moment from "moment";
import { GeneralTable, useModalAlert } from "../../GeneralComponents";
import KeyVariantIcon from "mdi-react/KeyVariantIcon";
import NewPassword from "./NewPassword";
import NotificationsUserConfig from "./NotificationsUserConfig";
import NotificationsIcon from "@material-ui/icons/Notifications";

export function UsersAdmin() {
  const [users, setUsers] = React.useState([]);
  const [openModal, setopenModal] = React.useState(null);
  const { showModalAlert } = useModalAlert();
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);
  const [isEditMode, setIsEditMode] = React.useState(true);
  const [listCountries, setListCountries] = React.useState([]);
  const [listDepartments, setListDepartments] = React.useState([]);
  const [listCities, setListCities] = React.useState([]);
  const [charges, setCharges] = React.useState([]);
  const [profiles, setProfiles] = React.useState([]);
  const [roles, setRoles] = React.useState(null);
  const [dependencias, setDependencias] = React.useState(null);
  const [listTipoDocumentos, setListTipoDocumentos] = React.useState([]);
  const [openNewPassword, setOpenNewPassword] = React.useState(false);
  const [infoUsuario, setInfoUsuario] = React.useState(false);
  const [listTypesNotification, setListTypesNotification] = React.useState([]);

  const [openModalNotificationUserConfig, setOpenModalNotificationUserConfig] =
    React.useState(false);

  const [formData, setFormData] = React.useState({
    id_pais: 38,
    id_dpto: 26,
  });
  const pais = formData.id_pais;
  const id_dep = formData.id_dpto;

  useEffect(() => {
    loadDataUser();
    loadCountries();
    loadCharge();
    loadRoles();
    loadProfiles();
    loadDependencias();
    loadTiposDocumentos();
  }, []);

  useEffect(() => {
    if (pais) {
      loadDepartments();
    }
  }, [pais]);

  useEffect(() => {
    if (id_dep) {
      loadCities();
    }
  }, [id_dep]);

  const handleCloseModal = () => {
    setopenModal(false);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const loadTiposDocumentos = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "tipo-documento/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaTipoDocumento = data.map((tipoDoc) => {
          return {
            value: tipoDoc.id,
            label: tipoDoc.nombre,
          };
        });
        setListTipoDocumentos(listaTipoDocumento);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadRoles = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "rol/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          const listaRoles = data.results.map((rol) => {
            return { value: rol.id_gd_roles, label: rol.nombre };
          });
          setRoles(listaRoles);
          console.log("rol", data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  const loadCountries = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "paises/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listCountries = data.map((pais) => {
          return {
            value: pais.id,
            label: pais.painom,
          };
        });
        setListCountries(listCountries);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadDepartments = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "departamentos/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listDepartments = data.map((departamento) => {
          return {
            value: departamento.id,
            label: departamento.depnom,
          };
        });
        setListDepartments(listDepartments);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadCities = async () => {
    var data = { id_dep: id_dep };
    await fetch(process.env.REACT_APP_PUBLIC_URL + "ciudades/listar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("ciudades", data);
        const listCities = data.map((city) => {
          return {
            value: city.id,
            label: city.ciunom,
          };
        });
        setListCities(listCities);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadCharge = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `cargo/listar?page=${page + 1}&page_size=${pageSize}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listCargos = data.results.map((cargo) => {
          return {
            value: cargo.id_cargo,
            label: cargo.cargo,
          };
        });
        setCharges(listCargos);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadDataUser = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          `usuario/listar?page=${page + 1}&page_size=${pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        },
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("Datosss---", data);

          setRowCount(data.count);
          const listadoUsuario = data.results.map((user) => ({
            ...user,
            id: user.id_usuario,
          }));

          setUsers(listadoUsuario);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  const onActivate = async (row) => {
    try {
      let dataSend = {
        id_usuario: row.id_usuario,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/activar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadDataUser();
      showModalAlert("success", "Se activo correctamente el usuario");
    } catch (error) {
      showModalAlert("danger", "Error al activar el usuario");
      console.error("Error:", error);
    }
  };

  const onInactivate = async (row) => {
    try {
      let dataSend = {
        id_usuario: row.id_usuario,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/inactivar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadDataUser();
      showModalAlert("success", "Se inactivo correctamente el usuario");
    } catch (error) {
      console.error("Error:", error);
      showModalAlert("danger", "Error al inactivar el usuario");
    }
  };

  const loadProfiles = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "perfiles/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((profiles) => {
          const listadoPerfil = profiles.results.map((perfil) => ({
            value: perfil.id_perfil,
            label: perfil.nombre,
          }));

          setProfiles(listadoPerfil);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  const loadDependencias = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "dependencia/listar?estado=A", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          const listaDependencias = data.results.map((dependencia) => {
            return {
              value: dependencia.id_gd_dependencia,
              label: dependencia.descripcion,
            };
          });
          setDependencias(listaDependencias);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  const loadNotificationsConfigModal = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "notificacion-configuracion/listar-tipos",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      },
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Ha ocurrido un error en el Servidor");
        }
      })
      .then((data) => {
        console.log("carga notificaciones ", data);

        setListTypesNotification(data);
        setOpenModalNotificationUserConfig(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      field: "nombre_usuario",
      headerName: "NOMBRE",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "usuario",
      headerName: "USUARIO",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "correo",
      headerName: "CORREO",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "nombre_perfil",
      headerName: "PERFIL",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "estado",
      headerName: "ESTADO",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) =>
        params.value != null
          ? params.value === "A"
            ? "Activa"
            : "Inactiva"
          : "No aplica",
    },
  ];

  const actionsList = [
    {
      title: "Cambiar contraseña",
      arialLabel: "change-password",
      icon: <KeyVariantIcon />,
      onClick: async (row) => {
        setOpenNewPassword(true);
        setInfoUsuario(row);
      },
    },
    {
      title: "Configurar notificaciones",
      arialLabel: "config-notification",
      icon: <NotificationsIcon />,
      onClick: async (row) => {        
        loadNotificationsConfigModal(true);
        setInfoUsuario(row);
      },
    },
  ];

  const newModalField = [
    {
      name: "usuario",
      label: "Nombre de usuario",
      type: "text",
      hidden: isEditMode,
    },
    {
      name: "password",
      label: "Contraseña",
      type: "password",
      hidden: isEditMode,
    },
    {
      name: "password2",
      label: "Confirma Contraseña",
      type: "password",
      hidden: isEditMode,
    },
    { name: "nombres", label: "Nombre completo", type: "mayuscula" },
    {
      name: "tip_documento",
      label: "Tipo documento",
      type: "select",
      options: listTipoDocumentos,
    },
    { name: "num_documento", label: "Numero de documento", type: "number" },
    { name: "celular", label: "Celular", type: "number" },
    { name: "correo", label: "Correo electronico", type: "email" },
    { name: "id_pais", label: "País", type: "select", options: listCountries },
    {
      name: "id_dpto",
      label: "Departamento",
      type: "select",
      options: listDepartments,
    },
    { name: "id_ciudad", label: "Ciudad", type: "select", options: listCities },
    { name: "direccion", label: "Dirección", type: "mayuscula" },
/*     { name: "id_perfil", label: "Perfil", type: "select", options: profiles }*/   
    /* {
      type: "label2",
      label: "Foto de perfil",
    },
    {
      name: "foto_perfil",
      label: "Subir foto perfil",
      type: "file-image",
      accept: ".png",
    }  */
  ];

  const requiredFields = [
    "nombres",
    "tip_documento",
    "num_documento",
    "correo",
    "celular",
    "id_pais",
    "id_dpto",
    "id_ciudad",
    "direccion",
  ];

  async function handleSave(formData) {
    let direccion = {
      id_pais: formData.id_pais,
      id_dpto: formData.id_dpto,
      id_ciudad: formData.id_ciudad,
      direccion: formData.direccion,
    };

    // Usar FormData para enviar archivos
    const datos = {
      ...formData,
      direccion: direccion,
    };
    const formDataToSend = new FormData();

    // Agregar todos los campos excepto foto_perfil
    Object.keys(datos).forEach((key) => {
      if (key !== "foto_perfil") {
        // Si es un objeto, serializarlo
        if (typeof datos[key] === "object" && datos[key] !== null) {
          formDataToSend.append(key, JSON.stringify(datos[key]));
        } else if (datos[key] !== undefined && datos[key] !== null) {
          formDataToSend.append(key, datos[key]);
        }
      }
    });

    // Agregar el archivo foto_perfil si existe
    if (formData.foto_perfil && formData.foto_perfil instanceof File) {
      formDataToSend.append("foto_perfil", formData.foto_perfil);
    }

    try {
      const url = isEditMode
        ? process.env.REACT_APP_PUBLIC_URL + "usuario/update"
        : process.env.REACT_APP_PUBLIC_URL + "usuario/create";

      const createResponse = await fetch(url, {
        method: isEditMode ? "PUT" : "POST",
        headers: {
          // No establecer Content-Type, el navegador lo hace automáticamente para FormData
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: formDataToSend,
      });

      const result = await createResponse.json();
      loadDataUser();
      setIsEditMode(false);
      handleCloseModal();
      if (isEditMode) {
        showModalAlert("success", "Se actualizo correctamente el usuario");
      } else {
        showModalAlert("success", "Se creo correctamente el usuario");
      }
    } catch (error) {
      console.error("No se creo correctamente", error);
      showModalAlert("danger", "Error al crear el usuario");
    }
  }

  return (
    <>
      <GeneralTable
        title=""
        titleAlert="Usuario"
        buttonText="Crear usuario"
        columns={columns}
        rows={users}
        rowCount={rowCount}
        pageSize={pageSize}
        page={page}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
        modalFields={newModalField}
        enableActivate
        onActivate={onActivate}
        onInactivate={onInactivate}
        initialFormData={{}}
        enableUpdate
        formData={formData}
        setFormData={setFormData}
        onSaveModal={handleSave}
        actionsList={actionsList}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
        width={"80%"}
        loadList={loadDataUser}
        isModalUser={true}
        requiredFields={requiredFields}
      />
      {openNewPassword ? (
        <NewPassword
          data={infoUsuario}
          openNewPassword={openNewPassword}
          setOpenNewPassword={setOpenNewPassword}
        />
      ) : null}
      {openModalNotificationUserConfig ? (
        <NotificationsUserConfig
          openModalNotificationUserConfig={openModalNotificationUserConfig}
          closeModalNotificationUserConfig={() => {
            setOpenModalNotificationUserConfig(false);
          }}
          listTypesNotification={listTypesNotification}
          dataUser={infoUsuario}
        />
      ) : null}
    </>
  );
}

